import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";

export const PaidFeaturesBanner = ({ isPaid }) => {
    if (!isPaid) return null;

    return (
        <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            className="bg-gradient-to-r from-[hsl(158,48%,32%)] to-[hsl(158,48%,38%)] rounded-xl px-5 py-3 flex items-center gap-3 shadow-sm"
        >
            <CheckCircle2 className="h-5 w-5 text-white" />
            <span className="text-white font-medium text-sm">All WhatsApp features unlocked!</span>
        </motion.div>
    );
};
